import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';

// AppSync configuration
const appSyncConfig = {
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT || process.env.REACT_APP_APPSYNC_GRAPHQL_ENDPOINT || '',
  aws_appsync_region: process.env.REACT_APP_AWS_REGION || 'us-west-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: process.env.REACT_APP_APPSYNC_API_KEY || '',
};

// Track if Amplify has been configured
let isAmplifyConfigured = false;

// Configure Amplify with AppSync
export const configureAppSync = () => {
  console.log('Configuring AppSync');
  try {
    // Validate required environment variables
    if (!appSyncConfig.aws_appsync_graphqlEndpoint) {
      return false;
    }
    
    if (!process.env.REACT_APP_COGNITO_USER_POOL_ID) {
      return false;
    }
    
    if (!process.env.REACT_APP_COGNITO_CLIENT_ID) {
      return false;
    }

    const amplifyConfig = {
      Auth: {
        Cognito: {
          userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
          userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        }
      },
      API: {
        GraphQL: {
          endpoint: appSyncConfig.aws_appsync_graphqlEndpoint,
          region: appSyncConfig.aws_appsync_region,
          defaultAuthMode: 'userPool' as const,
        }
      }
    };

    Amplify.configure(amplifyConfig);
    
    // Configure Cognito to use localStorage for token persistence
    // Create a custom storage that uses localStorage
    const customStorage = {
      setItem: (key: string, value: string) => {
        localStorage.setItem(key, value);
        return Promise.resolve();
      },
      getItem: (key: string) => {
        const value = localStorage.getItem(key);
        return Promise.resolve(value);
      },
      removeItem: (key: string) => {
        localStorage.removeItem(key);
        return Promise.resolve();
      },
      clear: () => {
        localStorage.clear();
        return Promise.resolve();
      }
    };
    
    cognitoUserPoolsTokenProvider.setKeyValueStorage(customStorage);
    
    console.log('✅ Amplify configured with localStorage for token persistence');
    isAmplifyConfigured = true;
    return true;
  } catch (error) {
    console.error('❌ Failed to configure AppSync:', error);
    return false;
  }
};

// Check if Amplify is configured
export const isConfigured = () => isAmplifyConfigured;

export { appSyncConfig };
